import { render, staticRenderFns } from "./DigitalSignature.vue?vue&type=template&id=dd0138da&"
import script from "./DigitalSignature.vue?vue&type=script&lang=js&"
export * from "./DigitalSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports